<div
  class="page-header"
  [class]="'page-header--' + direction() + ' page-header--justify-' + justify()"
>
  <h1 class="page-header__heading">{{ heading() }}</h1>
  <ng-content></ng-content>
</div>
